import { render, staticRenderFns } from "./DemoSimpleTableHeight.vue?vue&type=template&id=95333606&"
import script from "./DemoSimpleTableHeight.vue?vue&type=script&lang=js&"
export * from "./DemoSimpleTableHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
